/* ============================================================================
   FRAMESI.JS - Funcionalidad principal del tema
   ============================================================================ */

(function() {
  'use strict';

  /* ---------- Toast / Confirmación flotante ---------- */
  const SVG_CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12.6l4.2 4.2L19 7.4"/></svg>';

  function toast(titulo, detalle, accion) {
    const wrap = document.getElementById('toasts');
    if (!wrap) return;

    const el = document.createElement('div');
    el.className = 'toast';
    el.innerHTML = '<span class="tk" aria-hidden="true">' + SVG_CHECK + '</span>' +
      '<div class="tb"><b>' + escapeHtml(titulo) + '</b>' +
      (detalle ? '<span>' + escapeHtml(detalle) + '</span>' : '') + '</div>';

    if (accion && accion.label) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'ta';
      b.textContent = accion.label;
      b.onclick = function() {
        removeToast(el);
        if (accion.fn) accion.fn();
      };
      el.appendChild(b);

      el.addEventListener('focusin', function() {
        if (el._t) { clearTimeout(el._t); el._t = null; }
      });
      el.addEventListener('focusout', function() {
        if (!el._out && !el._t) el._t = setTimeout(function() { removeToast(el); }, 2600);
      });
    }

    wrap.appendChild(el);

    // Máximo 2 visibles
    while (wrap.children.length > 2) {
      const viejo = wrap.firstElementChild;
      if (viejo._t) clearTimeout(viejo._t);
      viejo._out = true;
      wrap.removeChild(viejo);
    }

    requestAnimationFrame(function() { el.classList.add('show'); });
    el._t = setTimeout(function() { removeToast(el); }, accion ? 5400 : 3600);
  }

  function removeToast(el) {
    if (!el || el._out) return;
    el._out = true;
    if (el._t) clearTimeout(el._t);
    el.classList.remove('show');
    setTimeout(function() {
      if (el.parentNode) el.parentNode.removeChild(el);
    }, 320);
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  // Exponer globalmente
  window.FramesiToast = toast;

  /* ---------- Acordeones ---------- */
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.acc-btn');
    if (!btn) return;

    const acc = btn.closest('.acc');
    if (!acc) return;

    const isOpen = acc.classList.contains('open');
    acc.classList.toggle('open');
    btn.setAttribute('aria-expanded', !isOpen);
  });

  /* ---------- Smooth scroll para links internos ---------- */
  document.addEventListener('click', function(e) {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;

    const hash = link.getAttribute('href');
    if (hash === '#') return;

    const target = document.querySelector(hash);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  /* ---------- Cerrar overlays con Escape ---------- */
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;

    // Cerrar menú móvil
    const mobileMenu = document.getElementById('framesi-mobile-menu');
    const menuOverlay = document.getElementById('framesi-menu-overlay');
    if (mobileMenu && mobileMenu.classList.contains('show')) {
      mobileMenu.classList.remove('show');
      if (menuOverlay) menuOverlay.classList.remove('show');
      return;
    }

    // Cerrar búsqueda
    const searchSheet = document.getElementById('framesi-search-sheet');
    const searchOverlay = document.getElementById('framesi-search-overlay');
    if (searchSheet && searchSheet.classList.contains('show')) {
      searchSheet.classList.remove('show');
      if (searchOverlay) searchOverlay.classList.remove('show');
      return;
    }

    /* Cerrar el cajón del carrito. La rama anterior buscaba `#cart-drawer.is-open`,
       un id y una clase que no existen en el tema: el cajón real es el
       <cart-drawer> de Dawn, que se abre con la clase `active`. Su propio
       manejador de Escape sólo escucha cuando el foco está DENTRO; éste cubre el
       caso en que el foco se quedó fuera. close() es idempotente. */
    const cajonAbierto = document.querySelector('cart-drawer.active');
    if (cajonAbierto && typeof cajonAbierto.close === 'function') {
      cajonAbierto.close();
      return;
    }
  });

  /* ---------- Carrito: contador, cajón y añadidos por AJAX -----------------
     Historia de esta parte:

     1. El añadido rápido cantaba éxito SIEMPRE (no miraba `res.ok`), tenía un
        `catch` mudo y borraba el contenido del botón. Eso se arregló antes y se
        conserva: se guarda y se restaura el innerHTML y el error de Shopify
        (`description`) se enseña tal cual.
     2. Nuevo: el añadido rápido y los formularios «Arma tu rutina» y
        Diagnóstico ahora abren y re-pintan el cajón de Dawn (<cart-drawer>) con
        la misma respuesta de /cart/add.js, pidiendo las secciones del cajón. Si
        no hay cajón (en /cart, o con otro tipo de carrito) queda el aviso
        flotante de siempre.
     3. Los formularios siguen siendo un POST normal a /cart/add con
        `return_to`: sin JavaScript funcionan igual. Esto es mejora progresiva.

     4. Aviso profesional del carrito: re-sincroniza «Pagar pedido» cuando Dawn
        re-pinta líneas (ver sincronizarPagoPro más abajo).

     Guardia `window.__fxCarrito`: si este archivo llegara a cargarse dos veces,
     los manejadores delegados no se duplican (dos POST por clic).
  ------------------------------------------------------------------------ */
  (function carrito() {
    if (window.__fxCarrito) return;
    window.__fxCarrito = true;

    const FORMAS_AJAX = 'form.fx-rutina__form, form[data-dx-form]';

    function rutaCarrito() {
      return (window.routes && window.routes.cart_url) || '/cart';
    }
    function rutaAgregar() {
      return ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    }
    function mensajeGenerico() {
      return (window.cartStrings && window.cartStrings.error) || 'Vuelve a intentarlo.';
    }
    function textoArticulos(n) {
      return 'Carrito, ' + n + ' ' + (n === 1 ? 'artículo' : 'artículos');
    }

    /* El <cart-drawer> sólo sirve si su clase ya está definida (cart-drawer.js
       es diferido y puede no haberse ejecutado todavía). */
    function cajon() {
      const d = document.querySelector('cart-drawer');
      return d && typeof d.renderContents === 'function' ? d : null;
    }

    function seccionesDelCajon(d) {
      try {
        return d.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      } catch (e) {
        return 'cart-drawer,cart-icon-bubble';
      }
    }

    function irAlCarrito() {
      const d = cajon();
      if (d && typeof d.open === 'function') d.open(document.getElementById('cart-icon-bubble'));
      else window.location.href = rutaCarrito();
    }

    /* El nombre accesible del icono. Si el <a> de la cabecera trae un
       aria-label fijo («Carrito, N artículos» pintado por Liquid) se queda
       viejo al cambiar el carrito; se re-escribe desde el número vivo. */
    function sincronizarEtiqueta() {
      const a = document.getElementById('cart-icon-bubble');
      if (!a || !a.hasAttribute('aria-label')) return;
      const c = a.querySelector('[data-cart-count]');
      if (!c) return;
      const n = parseInt(c.textContent, 10);
      if (!isNaN(n)) a.setAttribute('aria-label', textoArticulos(n));
    }

    /* Contador: se busca en el documento CADA vez (no se guardan nodos), así
       sobrevive a que Dawn cambie el interior de #cart-icon-bubble. */
    function pintarContador(n) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = n;
        if (n > 0) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
      document.querySelectorAll('[data-cart-count-texto]').forEach(function (el) {
        el.textContent = textoArticulos(n);
      });
      sincronizarEtiqueta();
    }

    function refrescarContador() {
      return fetch(rutaCarrito() + '.js', {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart.js ' + r.status);
          return r.json();
        })
        .then(function (carrito) {
          pintarContador(carrito.item_count);
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:actualizado', { detail: carrito, bubbles: true })
          );
          return carrito;
        })
        .catch(function () { /* el contador se queda como estaba: no se inventa */ return null; });
    }

    /* Avisa a Dawn (pubsub) SOLO si hay cajón: sus suscriptores lo re-pintan.
       Sin cajón (/cart) no se publica: CartItems.onCartUpdate solo re-pinta
       <cart-items> y deja viejos el pie (total, «Pagar») y la clase is-empty;
       ahí se usa repintarPagina(). publish() de pubsub.js llama a los
       suscriptores en el acto: si uno lanza, el producto YA se agregó, así que
       ese error no puede acabar en «No se pudo agregar». */
    function avisarCambio(datos) {
      if (!cajon()) return;
      if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      try {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'framesi', cartData: datos });
      } catch (e) {
        if (window.console) console.error(e);
      }
    }

    /* /cart sin cajón: el <cart-items> de cart.js, si su clase ya está definida. */
    function paginaCarrito() {
      const ci = document.querySelector('cart-items');
      if (!ci || typeof ci.getSectionsToRender !== 'function' || typeof ci.getSectionInnerHTML !== 'function') return null;
      if (!document.getElementById('main-cart-items') || !document.getElementById('main-cart-footer')) return null;
      return ci;
    }

    /* Las secciones que re-pinta cart.js en /cart, MENOS cart-live-region-text:
       esa sección imprime cart.total_price y, con una línea profesional, sería
       el precio de salón leído en voz alta. */
    function seccionesDePagina(pc) {
      try {
        return pc.getSectionsToRender().filter(function (s) { return s.id !== 'cart-live-region-text'; });
      } catch (e) {
        return [];
      }
    }

    function repintarPagina(pc, secciones, vacio) {
      pc.classList.toggle('is-empty', vacio);
      const pie = document.getElementById('main-cart-footer');
      if (pie) pie.classList.toggle('is-empty', vacio);
      const lista = document.getElementById('main-cart-items');
      /* Liquid pone el relleno de la sección solo si el carrito NO estaba vacío. */
      if (!vacio && lista && lista.dataset.id) pc.classList.add('section-' + lista.dataset.id + '-padding');
      seccionesDePagina(pc).forEach(function (s) {
        const html = secciones && secciones[s.section];
        const contenedor = document.getElementById(s.id);
        if (!html || !contenedor) return;
        const destino = contenedor.querySelector(s.selector) || contenedor;
        try {
          destino.innerHTML = pc.getSectionInnerHTML(html, s.selector);
        } catch (e) {
          if (window.console) console.error(e);
        }
      });
    }

    function releerPagina(pc, vacio) {
      const ids = seccionesDePagina(pc).map(function (s) { return s.section; }).join(',');
      if (!ids) return Promise.resolve();
      return fetch(window.location.pathname + '?sections=' + ids, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('sections ' + r.status);
          return r.json();
        })
        .then(function (secciones) { repintarPagina(pc, secciones, vacio); })
        .catch(function (e) { if (window.console) console.error(e); });
    }

    /* Agrega por /cart/add.js. Con cajón, pide sus secciones y lo re-pinta con
       la MISMA respuesta (una sola petición, como hace product-form.js). En
       /cart (sin cajón) pide las secciones de la página y las re-pinta.
       Devuelve { datos, abierto } o lanza un Error con el texto de Shopify. */
    function agregar(items, disparador) {
      const d = cajon();
      const pc = d ? null : paginaCarrito();
      const cuerpo = { items: items };
      if (d) {
        cuerpo.sections = seccionesDelCajon(d);
        cuerpo.sections_url = window.location.pathname;
      } else if (pc) {
        const ids = seccionesDePagina(pc).map(function (s) { return s.section; }).join(',');
        if (ids) {
          cuerpo.sections = ids;
          cuerpo.sections_url = window.location.pathname;
        }
      }

      return fetch(rutaAgregar(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(cuerpo)
      })
        .then(function (res) {
          /* Una respuesta que NO es JSON es error, no éxito: p. ej. una
             redirección que termina en una página HTML con 200 (tienda con
             contraseña, /challenge, mantenimiento). Tampoco cuenta como éxito
             un JSON sin `items`: /cart/add.js con `items` siempre los devuelve. */
          return res.json()
            .catch(function () { return null; })
            .then(function (datos) {
              const valido = !!datos && typeof datos === 'object';
              const fallo = !res.ok || !valido ||
                (typeof datos.status === 'number' && datos.status >= 400) ||
                !(Array.isArray(datos.items) || typeof datos.id === 'number');
              if (fallo) {
                /* Shopify manda `description` cuando algo falla (p. ej. «Ya no
                   hay existencias…»). Se enseña tal cual. */
                const err = new Error((valido && (datos.description || datos.message)) || mensajeGenerico());
                err.deShopify = valido;
                throw err;
              }
              return datos;
            });
        }, function () {
          /* Fallo de red: el texto del navegador («Failed to fetch») viene en
             inglés; se usa el mensaje del tema. */
          throw new Error(mensajeGenerico());
        })
        .then(function (datos) {
          let abierto = false;
          const cd = cajon();
          if (cd && datos.sections && datos.sections['cart-drawer']) {
            try {
              cd.classList.remove('is-empty');
              if (disparador) cd.setActiveElement(disparador);
              cd.renderContents(datos);
              abierto = true;
            } catch (e) {
              /* El producto YA se agregó: si el re-pintado falla no se dice
                 «no se pudo agregar». Se cae al aviso flotante. */
              abierto = false;
            }
          } else if (pc && datos.sections) {
            try {
              repintarPagina(pc, datos.sections, false);
            } catch (e) {
              if (window.console) console.error(e);
            }
          }
          avisarCambio(datos);
          return { datos: datos, abierto: abierto };
        });
    }

    function marcarOcupado(boton, ocupado) {
      if (!boton) return;
      boton.disabled = ocupado;
      if (ocupado) boton.setAttribute('aria-busy', 'true');
      else boton.removeAttribute('aria-busy');
    }

    /* ---- Añadir rápido (tarjetas de la rejilla) ---- */
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-quick-add]');
      if (!btn) return;

      e.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true') return;
      const variantId = parseInt(btn.getAttribute('data-product-id'), 10);
      const title = btn.getAttribute('data-product-title');
      if (!variantId) return;

      const contenidoOriginal = btn.innerHTML;
      const restaurar = function () {
        marcarOcupado(btn, false);
        btn.innerHTML = contenidoOriginal;
      };
      marcarOcupado(btn, true);

      agregar([{ id: variantId, quantity: 1 }], btn)
        .then(function (r) {
          restaurar();
          if (!r.abierto) {
            toast(title, 'Añadido al carrito', { label: 'Ver carrito', fn: irAlCarrito });
          }
          return refrescarContador();
        })
        .catch(function (err) {
          restaurar();
          toast('No se pudo agregar', (err && err.message) || mensajeGenerico());
        });
    });

    /* ---- «Arma tu rutina» (snippets/tienda-rutina.liquid → form.fx-rutina__form)
            y Diagnóstico (sections/diagnostico.liquid → form[data-dx-form]) ----
       Se leen los `items[N][id]` / `items[N][quantity]` que ya trae el
       formulario y se mandan por AJAX. Si no hay fetch o no hay líneas, NO se
       intercepta: sigue el POST normal con `return_to`. */
    function leerItems(form) {
      const porIndice = {};
      const items = [];
      new FormData(form).forEach(function (valor, clave) {
        const m = /^items\[(\d+)\]\[(id|quantity)\]$/.exec(clave);
        if (!m) return;
        porIndice[m[1]] = porIndice[m[1]] || {};
        porIndice[m[1]][m[2]] = parseInt(valor, 10);
      });
      Object.keys(porIndice)
        .sort(function (a, b) { return a - b; })
        .forEach(function (k) {
          const it = porIndice[k];
          if (it.id > 0) items.push({ id: it.id, quantity: it.quantity > 0 ? it.quantity : 1 });
        });
      return items;
    }

    document.addEventListener('submit', function (e) {
      const form = e.target;
      if (!form || typeof form.matches !== 'function' || !form.matches(FORMAS_AJAX)) return;
      if (e.defaultPrevented) return;
      if (typeof window.fetch !== 'function' || typeof window.FormData !== 'function') return;

      const items = leerItems(form);
      if (!items.length) return;

      e.preventDefault();
      if (form.getAttribute('data-fx-pendiente') === '1') return;
      form.setAttribute('data-fx-pendiente', '1');

      const boton = (e.submitter && form.contains(e.submitter)) ? e.submitter : form.querySelector('[type="submit"]');
      /* No se toca el texto del botón: diagnostico.js lo re-escribe al cambiar
         tamaños o el kit, y restaurar un innerHTML viejo lo pisaría. */
      marcarOcupado(boton, true);

      agregar(items, boton)
        .then(function (r) {
          if (!r.abierto) {
            toast(
              items.length === 1 ? 'Producto en el carrito' : 'Rutina en el carrito',
              items.length === 1 ? 'Añadido al carrito' : 'Se añadieron ' + items.length + ' productos',
              { label: 'Ver carrito', fn: irAlCarrito }
            );
          }
          return refrescarContador();
        })
        .catch(function (err) {
          toast('No se pudo agregar', (err && err.message) || mensajeGenerico());
          /* Con varias líneas Shopify puede haber agregado las primeras antes de
             rechazar una: se relee el carrito para no enseñar un cajón viejo.
             Con cajón, Dawn re-pinta líneas y pie (onCartUpdate); «Pagar» lo
             re-habilita sincronizarPagoPro (data-fx-vacio-off). En /cart se
             re-pintan las secciones de la página. */
          return refrescarContador().then(function (c) {
            if (!c) return;
            const d = cajon();
            if (d) {
              d.classList.toggle('is-empty', c.item_count === 0);
              avisarCambio(c);
              return;
            }
            const pc = paginaCarrito();
            if (pc) return releerPagina(pc, c.item_count === 0);
          });
        })
        .then(function () {
          marcarOcupado(boton, false);
          form.removeAttribute('data-fx-pendiente');
        });
    });

    /* Dawn re-escribe el interior de #cart-icon-bubble en cada cambio del
       carrito; se vuelve a sincronizar el nombre accesible cuando eso pasa. */
    (function vigilarIcono() {
      const a = document.getElementById('cart-icon-bubble');
      if (!a || typeof MutationObserver === 'undefined') return;
      new MutationObserver(sincronizarEtiqueta).observe(a, { childList: true });
      sincronizarEtiqueta();
    })();

    /* ---- Línea profesional en el carrito (aviso COSMÉTICO) ------------------
       snippets/cart-drawer.liquid, main-cart-items y main-cart-footer marcan
       cada línea de salón sin cuenta verificada con [data-fx-linea-pro] y
       apagan «Pagar pedido». Pero cart.js re-pinta por AJAX solo las líneas y
       el subtotal: el bloque del botón de /cart (y el .cart__ctas del cajón en
       onCartUpdate) se queda como estaba. Aquí se re-sincroniza botón, aviso y
       botones de pago acelerado según las líneas que HAY en pantalla.
       Solo re-habilita un botón que apagó esta regla (data-fx-pro-off): el
       «deshabilitado por carrito vacío» de Dawn no se toca.
       Esto oculta; no bloquea: /checkout se puede abrir directo. */
    const ZONAS_PRO = [
      /* en /cart se vigila <cart-items>: cart.js reemplaza su innerHTML entero */
      { zona: 'cart-items', pagar: '#checkout', aviso: '#Cart-ProBloqueo', dinamicos: true },
      { zona: 'cart-drawer', pagar: '#CartDrawer-Checkout', aviso: '#CartDrawer-ProBloqueo', dinamicos: false }
    ];

    function sincronizarPagoPro() {
      ZONAS_PRO.forEach(function (z) {
        const zona = document.querySelector(z.zona);
        const pagar = document.querySelector(z.pagar);
        if (!zona || !pagar) return;
        const bloqueado = !!zona.querySelector('[data-fx-linea-pro]');
        const hayLineas = !!zona.querySelector('.cart-item');
        const aviso = document.querySelector(z.aviso);
        /* Solo se toca un «Pagar» que apagó este tema: data-fx-pro-off (línea
           profesional) o data-fx-vacio-off (Liquid lo pintó con el carrito vacío).
           Caso medido por revisión: carrito vacío → «Arma tu rutina» agrega 2 de 3
           y falla → Dawn re-pinta líneas y pie del cajón pero NO .cart__ctas, y
           «Pagar» se quedaba con el disabled de «vacío» hasta recargar. */
        const loApagoElTema = pagar.hasAttribute('data-fx-pro-off') || pagar.hasAttribute('data-fx-vacio-off');
        if (bloqueado) {
          pagar.disabled = true;
          pagar.setAttribute('data-fx-pro-off', '');
          pagar.removeAttribute('data-fx-vacio-off');
          if (aviso) pagar.setAttribute('aria-describedby', aviso.id);
        } else {
          if (pagar.hasAttribute('data-fx-pro-off')) {
            pagar.removeAttribute('data-fx-pro-off');
            pagar.removeAttribute('aria-describedby');
          }
          if (hayLineas) {
            if (loApagoElTema) {
              pagar.disabled = false;
              pagar.removeAttribute('data-fx-vacio-off');
            }
          } else if (loApagoElTema || !pagar.disabled) {
            pagar.disabled = true;
            pagar.setAttribute('data-fx-vacio-off', '');
          }
        }
        if (aviso) aviso.hidden = !bloqueado;
        if (z.dinamicos) {
          document.querySelectorAll('[data-fx-pro-dinamicos]').forEach(function (el) { el.hidden = bloqueado; });
        }
      });
    }

    (function vigilarPagoPro() {
      sincronizarPagoPro();
      if (typeof MutationObserver === 'undefined') return;
      let pendiente = false;
      /* setTimeout y no requestAnimationFrame: en una pestaña oculta rAF no corre. */
      const obs = new MutationObserver(function () {
        if (pendiente) return;
        pendiente = true;
        setTimeout(function () { pendiente = false; sincronizarPagoPro(); }, 0);
      });
      ZONAS_PRO.forEach(function (z) {
        const zona = document.querySelector(z.zona);
        if (zona) obs.observe(zona, { childList: true, subtree: true });
      });
    })();

    /* ---- /cart: un solo <h1> VISIBLE también después de AJAX ---------------
       main-cart-items pinta <h1> el título si hay artículos y <h1> «Tu carrito
       está vacío» si no (el otro va como <h2>). Pero cart.js vacía o llena la
       página por AJAX cambiando solo la clase is-empty de <cart-items>: el <h1>
       quedaba con display:none y el título visible era un <h2>. Aquí se
       intercambian los niveles cada vez que cambia esa clase. */
    (function vigilarTitulosCarrito() {
      const ci = document.querySelector('cart-items');
      if (!ci || typeof MutationObserver === 'undefined') return;
      function cambiarNivel(el, tag) {
        if (!el || !el.parentNode || el.tagName.toLowerCase() === tag) return;
        const nuevo = document.createElement(tag);
        Array.prototype.forEach.call(el.attributes, function (at) { nuevo.setAttribute(at.name, at.value); });
        while (el.firstChild) nuevo.appendChild(el.firstChild);
        el.parentNode.replaceChild(nuevo, el);
      }
      function fijar() {
        const vacio = ci.classList.contains('is-empty');
        cambiarNivel(ci.querySelector('.title-wrapper-with-link .title--primary'), vacio ? 'h2' : 'h1');
        cambiarNivel(ci.querySelector('.cart__warnings .cart__empty-text'), vacio ? 'h1' : 'h2');
      }
      new MutationObserver(fijar).observe(ci, { attributes: true, attributeFilter: ['class'] });
      fijar();
    })();

    /* «Quitar del carrito» del aviso profesional: es un enlace real a
       item.url_to_remove (funciona sin JS). Con cart.js cargado se quita por
       AJAX, igual que el icono de papelera de Dawn, sin recargar la página. */
    document.addEventListener('click', function (e) {
      const a = e.target.closest('.fx-linea-pro__quitar[data-index]');
      if (!a) return;
      const lista = a.closest('cart-items, cart-drawer-items');
      if (!lista || typeof lista.updateQuantity !== 'function') return;
      e.preventDefault();
      lista.updateQuantity(a.getAttribute('data-index'), 0);
    });

    window.FramesiCarrito = {
      agregar: agregar,
      refrescarContador: refrescarContador,
      abrir: irAlCarrito
    };
  })();

  /* ---------- Paneles: aria-hidden sincronizado con la clase ---------------
     El cajón de menú y la hoja de búsqueda traían `aria-hidden="true"` FIJO en el
     marcado. Cerrados mentía a medias (seguían siendo enfocables) y abiertos
     mentía del todo: para un lector de pantalla el panel no existía.
     Se abren y cierran con `classList` desde manejadores en línea repartidos por
     el marcado, así que en vez de tocar cada uno se observa la clase.
  ------------------------------------------------------------------------ */
  (function sincronizarPaneles() {
    const paneles = document.querySelectorAll('[data-panel]');
    if (!paneles.length || typeof MutationObserver === 'undefined') return;
    const sincronizar = function (el) {
      el.setAttribute('aria-hidden', el.classList.contains('show') ? 'false' : 'true');
    };
    const obs = new MutationObserver(function (muts) {
      muts.forEach(function (m) { sincronizar(m.target); });
    });
    paneles.forEach(function (el) {
      sincronizar(el);
      obs.observe(el, { attributes: true, attributeFilter: ['class'] });
    });
  })();

  /* ---------- Paneles: foco al abrir y devolución al cerrar (segunda pasada) ----------
     Medido a 1024 px: el menú móvil abre y el foco se queda en <body>; al cerrar,
     quien navega con teclado vuelve al principio del documento. El observador de
     arriba ya sincroniza aria-hidden; esto sólo mueve el foco, sin tocar los
     manejadores en línea del marcado. Guarda de una sola vez. */
  (function focoPaneles() {
    if (window.__fxFocoPaneles) return;
    window.__fxFocoPaneles = true;
    const paneles = document.querySelectorAll('[data-panel]');
    if (!paneles.length || typeof MutationObserver === 'undefined') return;
    let disparador = null;
    document.addEventListener('pointerdown', function (e) {
      const b = e.target.closest && e.target.closest('button, a');
      if (b && !b.closest('[data-panel]')) disparador = b;
    }, true);
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && document.activeElement && !document.activeElement.closest('[data-panel]')) {
        disparador = document.activeElement;
      }
    }, true);
    const enfocables = 'input:not([type=hidden]), a[href], button:not([disabled]), select, textarea';
    const obs = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        const el = m.target;
        const abierto = el.classList.contains('show');
        if (abierto && !el.contains(document.activeElement)) {
          const primero = el.querySelector('input[type=search]') || el.querySelector(enfocables);
          if (primero) primero.focus({ preventScroll: true });
        } else if (!abierto && el.contains(document.activeElement)) {
          if (disparador && document.contains(disparador)) disparador.focus({ preventScroll: true });
        }
      });
    });
    paneles.forEach(function (el) { obs.observe(el, { attributes: true, attributeFilter: ['class'] }); });
  })();

  /* ---------- Inicialización ---------- */
  document.addEventListener('DOMContentLoaded', function() {
    // Agregar clase loaded al body
    document.body.classList.add('framesi-loaded');
  });

})();
